import React from "react";
import { Link } from "react-router-dom";

import cn from "@/utils/cn";

type Props = {
  to: string;
  name: string;
  icon?: React.ReactElement;
  isCurrent: boolean;
  onNavigate?: () => void;
};

export const SidebarNavNestedLink = ({
  to,
  name,
  icon,
  isCurrent,
  onNavigate,
}: Props) => {
  return (
    <Link
      to={to}
      onClick={onNavigate}
      className={cn(
        "flex h-12 items-center gap-x-2.5 rounded-md py-3 pl-8 pr-3 text-[13px] font-medium leading-4 tracking-[0.26px] transition-all duration-300 hover:bg-chorus-black-200",
        isCurrent
          ? "bg-chorus-black-200 text-chorus-gray-300"
          : "text-chorus-gray-500",
      )}
      data-testid={name}
    >
      {icon &&
        React.cloneElement(icon, {
          className: cn(
            "size-6 shrink-0",
            isCurrent ? "fill-chorus-gray-400" : "fill-chorus-gray-600",
          ),
        })}
      <span className="whitespace-nowrap">{name}</span>
    </Link>
  );
};
